import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => {

	return {
		commentAvatar: {
			...theme.other.rooterAvatars.size30,
			...theme.other.rooterAvatars.borderRadius,
			objectFit: "cover"
		},
		commentInput: {
			fontSize     : "14px",
			padding      : "0rem 0.75rem",
			width        : "100%",
			zIndex       : "1",
			border       : "none",
			borderRadius : "4.5rem",

			"&:has([data-position=\"left\"])": {
				"& :nth-child(2)": {
					paddingInlineStart: "4rem"
				}
			}

		},
		commentInputFocused: {
			fontSize     : "14px",
			padding      : "1rem 1.2rem",
			width        : "100%",
			zIndex       : "1",
			border       : "solid 2px #126bd5",
			borderRadius : "30px"
		},
		textField: {
			height         : "40px",
			display        : "flex",
			justifyContent : "center",
			overflow       : "hidden"

		},
		commentInputContainer: {
			display         : "flex",
			alignItems      : "center",
			justifyContent  : "space-between",
			padding         : "1.25rem 1rem",
			backgroundColor : theme.other.colors.dialog.secondary,

			"& .MuiOutlinedInput-root": {
				"& fieldset": {
					borderRadius : "30px",
					border       : "none",
					// background   : "#e7e7e7"
					background   : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey20 : theme.other.paletteNew.secondaryLightGrey

				},
				"& input": {
					// width : "fit-content",
					color: theme.other.colors.text.primary
				},
				"& input::placeholder": {
					fontSize : "1.2rem !important",
					color    : theme.other.colors.text.primary

				}
			},
			"& .MuiFormControl-root": {
				height       : "auto",
				width        : "100%",
				borderRadius : "5px"
			}
		},
		btnRootContainer: {
			background    : theme.other.colors.input.disabled,
			border        : "none",
			height        : "4.8rem",
			paddingInline : "1.5rem",
			borderRadius  : "100rem"
		},
		btnLabel: {
			color      : theme.other.colors.text.primary,
			fontWeight : 100
		},
		commentRootContainer: {
			background   : theme.other.colors.input.primary,
			border       : "none",
			color        : theme.other.colors.text.primary,
			minHeight    : !props?.disabled ? "3.5rem" : "unset",
			padding      : "2.4rem",
			borderRadius : "100rem",

			"&[data-disabled]": {
				background: theme.other.colors.input.disabled
			},

			"& :focus": {
				outline: `2px solid ${ theme.other.paletteNew.primaryDarkBlue }`
			}
		},
		commentRootFixedHeight: {
			height: "3.5rem"
		},
		chatPopIcon: {
			padding : "4px 0 0 4px",
			cursor  : "pointer"
		},
		sendIcon: {
			background : "none",
			cursor     : "pointer",
			width      : "3.6rem !important",
			height     : "3.6rem !important",
			transition : "opacity 0.1s ease-in-out",
			zIndex     : "99",

			"&[data-disabled]": {
				opacity: "0.5"
			}

		},
		svgIconsDark: {
			width     : "3.5rem",
			height    : "3.5rem",
			display   : "flex",
			alignSelf : "center",
			cursor    : "pointer"
		},
		svgIcons: {
			width     : "3.5rem",
			height    : "3.5rem",
			display   : "flex",
			alignSelf : "center",
			cursor    : "pointer"
		},
		svgIcon: {
			height         : "3.5rem",
			width          : "3.5rem",
			display        : "flex",
			justifyContent : "center",
			borderRadius   : "100%",
			cursor         : "pointer"
		},
		settingsIcon: {
			marginLeft: "0.5em"
		},
		emoteContainer: {
			display                : "flex",
			flexDirection          : "row",
			justifyContent         : "space-between",
			padding                : "0.5rem",
			overflow               : "auto",
			"&::-webkit-scrollbar" : {
				width      : "0", /* Remove scrollbar space */
				background : "transparent" /* Optional: just make scrollbar invisible */
			}
		},
		emoteListContainer: {
			display        : "flex",
			flexDirection  : "row",
			justifyContent : "space-between",
			cursor         : "pointer"
		},
		emotesMargin: {
			marginRight : "1rem",
			width       : "30px",
			height      : "30px"
		},
		tooltip: {
			color           : "white",
			backgroundColor : "rgba(34, 34, 34, 1)",
			fontSize        : "10px",
			maxWidth        : 500
		},
		rightSvgIcon: {
			display   : "flex",
			alignSelf : "center"
		},
		iconsInteractionCtn: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "space-between",
			padding        : "1rem 1rem 1rem 1rem",
			background     : theme.other.colors.dialog.secondary,
			zIndex         : "50"
		},
		emojiContainer: {
			cursor       : "pointer",
			marginLeft   : props?.isStreamer ? "1rem" : 0,
			outline      : props?.displayEmoji ? "solid 2px #126bd5" : 0,
			borderRadius : "50%"
		},
		emojiModalParent: {
			height     : props?.displayEmoji ? "210px" : 0,
			transition : "height 0.5s ease-in-out",

			"& .EmojiPickerReact li.epr-emoji-category>.epr-emoji-category-label": {
				color: `${ theme.other.colors.text.primary } !important`
			}
		}
	};
} );
